
const showRegisterBtn = document.getElementById('showRegisterBtn');
const showAuthBtn = document.getElementById('showAuthBtn');

const registrationDiv = document.getElementById('registrationDiv');
const authDiv = document.getElementById('authDiv');


if (!(showRegisterBtn instanceof HTMLElement) || !(showAuthBtn instanceof HTMLElement)){
    throw new Error("Ошибка ! Кнопки переключений форм регистарции не найдены");
}

if (!(authDiv instanceof HTMLDivElement) || !(registrationDiv instanceof HTMLDivElement)){
    throw new Error("Ошибка ! Блоки регистраций не найдены");
}

/**
 * Показываем форму регистрации
*/
const showRegisterForm = () => {
    authDiv.style.display = 'none';
    registrationDiv.style.display = 'flex';
}

/**
 * Показываем форму авторизации
 */
const showAuthForm = () => {
    authDiv.style.display = 'flex';
    registrationDiv.style.display = 'none';
}


export const initSwitchAuthForm  = () => {
    showAuthBtn.addEventListener('click', showAuthForm);
    showRegisterBtn.addEventListener('click', showRegisterForm);
}